const GuideHero = () => {
  return (
    <section className="relative min-h-[50vh] sm:min-h-[60vh] flex items-center justify-center overflow-hidden bg-gradient-to-br from-red-dark to-red">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik0zNiAxOGMzLjMxNCAwIDYgMi42ODYgNiA2cy0yLjY4NiA2LTYgNi02LTIuNjg2LTYtNiAyLjY4Ni02IDYtNnoiIHN0cm9rZT0iI2ZmZiIgc3Ryb2tlLXdpZHRoPSIyIi8+PC9nPjwvc3ZnPg==')]"></div>
      </div>

      <div className="relative z-10 max-w-[1400px] mx-auto px-4 sm:px-8 w-full text-center">
        <div className="inline-block mb-4 sm:mb-6 px-4 sm:px-5 py-2 border border-white/30 bg-white/15 backdrop-blur-sm rounded-full">
          <span className="text-white text-xs sm:text-[13px] font-medium">
            税理士選びのポイント
          </span>
        </div>

        <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-[1.2] mb-4 sm:mb-6 px-4">
          良い税理士の<br className="sm:hidden" />見分け方
        </h1>

        <p className="text-base sm:text-lg text-white/90 leading-relaxed max-w-3xl mx-auto px-4">
          税理士選びは経営の成否を左右する重要な決断です。<br className="hidden sm:block" />
          良い税理士を見分けるポイントをご紹介します。
        </p>
      </div>
    </section>
  );
};

export default GuideHero;
